import { createApi } from '@reduxjs/toolkit/query/react';

import { API_URL } from '../../../common/constants/api-url';
import { getBaseQuery } from '../base-query';
import { PageStatusesResBody } from './page-statuses-api-types';

export const pageStatusesApiSlice = createApi({
  baseQuery: getBaseQuery({
    baseUrl: `${API_URL}/admin/agg-pages/status`
  }),
  endpoints: (builder) => ({
    getStatuses: builder.query<PageStatusesResBody, null>({
      query: () => ({
        method: 'GET',
        url: '',
      })
    })
  }),
  reducerPath: 'pageStatuses'
});
